import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import parse from 'html-react-parser';

import Container from '../../containers/Container';
import Button from '../../components/Button';
import Grid from '../../components/Grid';
import PdfLoader from '../../utils/PdfLoader';
import HexaText from '../../components/HexaText';
import caption from '../../res/caption.jpg';
import styles from './styles';

import { ReactComponent as HexaSvg2 } from '../../res/hexa2.svg';
import { ReactComponent as HexaSvg3 } from '../../res/hexa3.svg';
import { ReactComponent as HexaSvg4 } from '../../res/hexa4.svg';
import { ReactComponent as HexaSvg5 } from '../../res/hexa5.svg';

class FichesActionsTypes extends React.Component {
  onClickHexa(id) {
    const container = document.getElementById('fiches-actions-types');
    const element = document.getElementById(id);
    if (element && element) {
      window.scroll({ top: container.offsetTop + element.offsetTop, behavior: 'smooth' });
    }
  }

  render() {
    const { classes, data } = this.props;
    const { 'actions-types': block } = data.fiches;
    const axes = ['purpule', 'green', 'blue', 'blueLight', 'red', 'orange', 'greenLight'];
    return (
      <Container id="fiches-actions-types" className={classes.container}>
        <div className={classes.titleContainer}>
          <Typography className={classes.title} variant="h1">
            {parse(block.title)}
          </Typography>
        </div>
        <div className={classes.hexaContainer}>
          <div className={classes.hexaInnerContainer}>
            {axes.map((color, axe) => (
              <HexaText
                key={color}
                className={`${classes.hexa} hexa hexa${axe + 1}`}
                onClick={() => this.onClickHexa(`axe${axe + 1}`)}
              >
                <div className={classes.hexaInner}>
                  <Typography className={classes.hexaTitle}>{parse(block[`axe${axe + 1}`].title)}</Typography>
                  <Typography variant="body2" className={classes.hexaSubtitle}>
                    {parse(block[`axe${axe + 1}`].subtitle)}
                  </Typography>
                </div>
              </HexaText>
            ))}
          </div>
        </div>
        <div className={classes.captionContainer}>
          <div className={classes.captionInner}>
            <Typography className={classes.captionTitle}>{parse(block.caption.title)}</Typography>
            <Typography variant="body2" className={classes.captionDesc}>
              {parse(block.caption.desc)}
            </Typography>
            <img className={classes.captionImg} src={caption} alt={block.caption.title} />
          </div>
        </div>
        {axes.map((color, axe) => (
          <div key={axe} className={classes.axeContainer} id={`axe${axe + 1}`}>
            {axe === 1 ? <HexaSvg3 className={classes.hexaSvg3} /> : null}
            {axe === 3 ? <HexaSvg4 className={classes.hexaSvg4} /> : null}
            {axe === 3 ? <HexaSvg2 className={classes.hexaSvg2} /> : null}
            {axe === 4 ? <HexaSvg5 className={classes.hexaSvg5} /> : null}
            <div className={`${classes.axeTitleContainer} ${classes[`axe${axe + 1}TitleContainer`]}`}>
              <Typography variant="h2" className={classes.axeTitle}>
                {parse(block[`axe${axe + 1}`].title)}
              </Typography>
              <Typography variant="subtitle1" className={classes.axeSubtitle}>
                {parse(block[`axe${axe + 1}`].subtitle)}
              </Typography>
              <div className={`${classes.axeTitleSep} ${classes[`axe${axe + 1}TitleSep`]}`}></div>
            </div>
            <Grid
              lg={3}
              md={4}
              sm={6}
              xs={12}
              id={`axe${axe + 1}`}
              className={`${classes.axeContent} ${classes[`axe${axe + 1}Content`]}`}
            >
              {block[`axe${axe + 1}`].fiches.map((fiche, idx) => (
                <div key={idx} className={classes.ficheContainer}>
                  <Typography variant="h5" className={classes.ficheNum}>
                    {parse(fiche.num)}
                  </Typography>
                  <Typography variant="h5" className={classes.ficheTitle}>
                    {parse(fiche.title)}
                  </Typography>
                  <Button color={color} size="small" onClick={PdfLoader(fiche.pdf)}>
                    {parse(block['button-read'])}
                  </Button>
                </div>
              ))}
            </Grid>
          </div>
        ))}
      </Container>
    );
  }
}

FichesActionsTypes.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FichesActionsTypes);
